import React from "react";
import { X } from "lucide-react";

export default function CancelSidebar({
  isOpen,
  onClose,
  reason,
  setReason,
  onCancelAppointment,
}) {
  return (
    <div className="fixed top-0 right-0 z-50 h-full w-full max-w-md bg-white shadow-lg border-l border-gray-200 p-6 overflow-y-auto">
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-lg font-semibold text-[#004276]">
        Close
        </h2>
        <button onClick={onClose}>
          <X className="w-5 h-5 text-gray-500 hover:text-gray-700" />
        </button>
      </div>

      {/* Form */}
      <div className="space-y-6">
        <div>
          <label className="text-sm font-medium text-gray-600">Reason</label>
          <textarea
            placeholder="Please type here"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            rows={5}
            className="mt-1 w-full px-4 py-3 border border-gray-300 rounded-md text-sm resize-none"
          />
        </div>

        <div className="flex justify-end mt-10">
          <button
            onClick={onCancelAppointment}
            className="w-full px-6 py-2 bg-[#004276] text-white rounded-full text-sm hover:bg-[#00365f] transition"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
